import script from "./BottomFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomFooter.vue?vue&type=script&setup=true&lang=js"

import "./BottomFooter.vue?vue&type=style&index=0&id=1141e5bf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1141e5bf"]])

export default __exports__